import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=4764aa79&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutContactForm: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/about/AboutContactForm.vue').default})
